import React from 'react';
import { StatusBarStyle, TouchableOpacity } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import { truncate } from 'lodash';
import { Moment } from 'moment';
import styled from 'styled-components/native';

import Avatar from '@src/components/Avatar';
import { H2, Subtitle1 } from '@src/components/Typography';
import { User } from '@src/types';

type Props = {
  date?: Moment;
  user?: User;
  barStyle?: StatusBarStyle;
  maxTextLength?: number;
};

const Container = styled.View`
  padding-start: 10px;
  flex-direction: row;
  align-items: center;
`;

const Content = styled.View`
  padding-start: 10px;
  justify-content: space-around;
`;

const WhiteTitle = styled(H2)`
  color: ${({ theme }) => theme.colors.onPrimary};
`;

const WhiteCaption = styled(Subtitle1)`
  color: ${({ theme }) => theme.colors.onPrimary};
`;

const Component: React.FC<Props> = ({
  user,
  date,
  barStyle,
  maxTextLength = 24,
}) => {
  const navigation = useNavigation();
  const handlePress = React.useCallback(() => {
    if (user) {
      navigation.navigate('Profile', { id: user.id });
    }
  }, [navigation, user]);
  return (
    <TouchableOpacity onPress={handlePress}>
      <Container>
        <Avatar source={user?.avatar} />
        {barStyle === 'dark-content' ? (
          <Content>
            <WhiteTitle>
              {truncate(user?.name, { length: maxTextLength })}
            </WhiteTitle>
            <WhiteCaption>{date?.fromNow()}</WhiteCaption>
          </Content>
        ) : (
          <Content>
            <H2>{user?.name}</H2>
            <Subtitle1>{date?.fromNow()}</Subtitle1>
          </Content>
        )}
      </Container>
    </TouchableOpacity>
  );
};

Component.displayName = 'UserTag';

export default React.memo(Component);
